
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

export const usePlotExpenses = (plotId: string | undefined) => {
  const { toast } = useToast();

  const { data: plotExpenses = [], isLoading, refetch } = useQuery({
    queryKey: ['plot-expenses', plotId],
    queryFn: async () => {
      if (!plotId) return [];

      const { data, error } = await supabase
        .from('expenses')
        .select(`
          *,
          expense_categories (
            name
          )
        `)
        .eq('entity_id', plotId)
        .eq('entity_type', 'plot')
        .order('expense_date', { ascending: false });

      if (error) {
        console.error('Error fetching plot expenses:', error);
        toast({
          title: "Error",
          description: "No se pudieron cargar los gastos de la parcela",
          variant: "destructive",
        });
        throw error;
      }

      return data.map(expense => ({
        ...expense,
        entity_type: expense.entity_type as 'plot' | 'house'
      })) || [];
    },
    enabled: !!plotId,
  });

  return { plotExpenses, isLoading, refetchPlotExpenses: refetch };
};
